import React, { useState, useEffect } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import FormInput from '../../../components/Forms/FormInput';

const UserForm = ({ user, onSubmit, onCancel, loading }) => {
    const [formData, setFormData] = useState({
        username: '',
        email: '',
        first_name: '',
        last_name: '',
        phone_number: '',
        valor_hora: 0,
        is_active: true,
        password: '',
        re_password: '',
    });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (user) {
            setFormData({
                username: user.username || '',
                email: user.email || '',
                first_name: user.first_name || '',
                last_name: user.last_name || '',
                phone_number: user.phone_number || '',
                valor_hora: user.valor_hora || 0,
                is_active: user.is_active ?? true,
                password: '',
                re_password: '',
            });
        }
    }, [user]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
        if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.username.trim()) newErrors.username = 'Requerido';
        if (!formData.email.trim()) newErrors.email = 'Requerido';
        else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Email inválido';
        if (!formData.first_name.trim()) newErrors.first_name = 'Requerido';
        if (!formData.last_name.trim()) newErrors.last_name = 'Requerido';
        if (!formData.phone_number.trim()) newErrors.phone_number = 'Requerido';
        else if (!/^\d{10}$/.test(formData.phone_number)) newErrors.phone_number = '10 dígitos';

        if (!user) {
            if (!formData.password) newErrors.password = 'Requerida';
            else if (formData.password.length < 8) newErrors.password = 'Mínimo 8 caracteres';
            if (!formData.re_password) newErrors.re_password = 'Confirma contraseña';
            else if (formData.password !== formData.re_password) newErrors.re_password = 'No coinciden';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) onSubmit(formData);
    };

    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
            <div className="relative top-20 mx-auto p-5 border w-full max-w-2xl shadow-lg rounded-md bg-white">
                <div className="flex justify-between items-center pb-3 border-b">
                    <h3 className="text-xl font-medium text-gray-900">
                        {user ? 'Editar Usuario' : 'Crear Usuario'}
                    </h3>
                    <button onClick={onCancel} className="text-gray-400 hover:text-gray-500">
                        <XMarkIcon className="h-6 w-6" />
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="mt-4 space-y-4 max-h-96 overflow-y-auto">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <FormInput
                            label="Usuario"
                            name="username"
                            value={formData.username}
                            onChange={handleChange}
                            error={errors.username}
                            required
                        />

                        <FormInput
                            label="Email"
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            error={errors.email}
                            required
                        />

                        <FormInput
                            label="Nombre"
                            name="first_name"
                            value={formData.first_name}
                            onChange={handleChange}
                            error={errors.first_name}
                            required
                        />

                        <FormInput
                            label="Apellido"
                            name="last_name"
                            value={formData.last_name}
                            onChange={handleChange}
                            error={errors.last_name}
                            required
                        />

                        <FormInput
                            label="Teléfono"
                            type="tel"
                            name="phone_number"
                            value={formData.phone_number}
                            onChange={handleChange}
                            error={errors.phone_number}
                            required
                        />

                        <FormInput
                            label="Valor por Hora"
                            type="number"
                            name="valor_hora"
                            value={formData.valor_hora}
                            onChange={handleChange}
                        />

                        {!user && (
                        <>
                            <FormInput
                                label="Contraseña"
                                type="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                error={errors.password}
                                required
                            />

                            <FormInput
                                label="Confirmar Contraseña"
                                type="password"
                                name="re_password"
                                value={formData.re_password}
                                onChange={handleChange}
                                error={errors.re_password}
                                required
                            />
                        </>
                        )}
                    </div>

                    <div className="flex items-center">
                        <input
                            id="is_active"
                            name="is_active"
                            type="checkbox"
                            checked={formData.is_active}
                            onChange={handleChange}
                            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                        />
                        <label htmlFor="is_active" className="ml-2 block text-sm text-gray-900">
                            Usuario activo
                        </label>
                    </div>

                    <div className="flex justify-end space-x-3 pt-4 border-t">
                        <button
                            type="button"
                            onClick={onCancel}
                            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            disabled={loading}
                            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 disabled:opacity-50"
                        >
                            {loading ? 'Guardando...' : (user ? 'Actualizar' : 'Crear')}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UserForm;